// Session selectors
export const getToken = state => state.session?.token
export const getUserProfile = state => state.session?.profile
export const getSessionIsRequesting = state => state.session?.isRequesting

// Organisation Selectors
export const getActiveOrganisationId = state => state.organisation?.active?.organisationId
export const getActiveOrganisation = state => state.organisation?.active
export const hasAdminPermissions = state => {
  if (state.organisation?.active) {
    const ADMIN_PERMISSIONS = ['OWNER']

    return state.organisation.active.permissions
      .some(permission => ADMIN_PERMISSIONS.includes(permission))
  }

  return false
}

// Settings Selectors
export const getSettingsInboxesState = state => state.settingsInboxes
export const prepareSettingInboxesToSave = state => {
  const inboxes = []

  state.settingsInboxes.collection.forEach(item => {
    inboxes.push(...item.inboxes)
  })

  return inboxes
}

// Inboxes Selectors
export const getInboxesState = state => state.inboxes

// Interactions Selectors
export const getInteractionsState = state => state.interactions
export const getInteractions = state => state.interactions.collection
export const getInteractionsPages = state => state?.interactions?.pages
export const getInteractionsPage = state => state.interactions.page
export const getInteractionsNextPage = state => {
  const {
    page,
    pages
  } = state.interactions

  const nextPage = parseInt(page) + 1
  if (pages > 0 && nextPage > pages) {
    return null // don't return  boolean
  }

  return nextPage
}
export const areInteractionsRequesting = state => state?.interactions?.isRequesting

// Activities Selectors
export const getActivitiesState = state => state?.activities
export const getActivities = state => state?.activities?.collection
export const getActivitiesScrollToBottomRequired = state => state?.activities.scrollToBottomRequired
export const getActivitiesScrollToTopRequired = state => state?.activities.scrollToTopRequired
export const areActivitiesLoading = state => state?.activities?.isRequesting
export const getActivitiesPages = state => state?.activities?.pages
export const getActivitiesPage = state => state?.activities?.page
export const getActivitiesNextPage = state => {
  const {
    page,
    pages
  } = state.activities

  const nextPage = parseInt(page) + 1
  if (pages > 0 && nextPage > pages) {
    return -1
  }

  return nextPage
}

// Selected state selector
export const getSelectedState = state => state.selected

// Selected filter and inboxes Selectors
export const getSelectedInbox = state => state.selected.inbox
export const getSelectedInboxTitle = state => state.selected.inbox?.title
export const getSelectedFilter = state => state.selected.filter

// Selected Interaction Selectors
export const getSelectedInteraction = state => state.selected.interaction
export const getActiveAgentId = state => state.selected.interaction?.agentId
export const getSelectedInteractionId = state => state.selected.interaction?.interactionId
export const showCompose = state => {
  return state.selected.interaction?.threads[0]?.channelName !== 'twiliovoice'
}
export const getSelectedInteractionThreadIds = state => {

  const threads = state?.selected?.interaction?.threads?.map(t => ({
    threadId: t.threadId,
    channelId: t.channelId,
    channelName: t.channelName
  }))

  return threads
}
export const checkIsActivityPaused = state => {
  let pausedThreadData = null

  return state.selected.interaction.threads.reduce((acc, interactionTread) => {
    state.pauses.threads.forEach(pausedThread => {
      if (pausedThread.threadId === interactionTread.threadId) {
        acc = true
        pausedThreadData = pausedThread
      }
    })
    return acc
  }, false)
}
export const getSelectedInteractionThreadIdsStringified = state => {

  const threads = state?.selected?.interaction?.threads?.map(t => ({
    threadId: t.threadId,
    channelId: t.channelId
  }))

  return JSON.stringify(threads)
}

// Events selectors
export const getTriggerEvents = state => state.selected.triggerEvents
export const prepareThreadsForTriggerEvent = state => state.selected.interaction.threads[0]
export const prepareEventNameForTriggerEvent = state => state.selected.triggerEvents[0]
export const prepareActorForTriggerEvent = state => {

  const {
    selected: {
      interaction: {
        participants
      }
    }
  } = state

  const external = participants.find(participant => participant && participant.role === 'external')

  const actor = {
    ...external,
    userId: external.handles ? external.handles[0].userId : external.userId
  }

  return actor
}

export const isSocketReconnectionError = state => state.socket.socketReconnectionError

export const getCounters = state => state.counters

export const getRequestsState = state => state.requests.requests

export const getCustomerId = state => state.selected.profile?.customerId
export const getFullName = state => state.selected.profile?.fullName
export const getFirstActivity = state => state.selected.profile?.firstActivity
export const getLastActivity = state => state.selected.profile?.lastActivity
export const getProfile = state => state.selected.profile
export const getTags = state => state?.originator?.tags
export const getBusyTypingCollection = state => state?.interactions?.isBusyTyping

export const isSocketInteraction = state => state.selected?.interaction?.threads && state.selected.interaction.threads[0].channelName === 'socket'
export const lastExternalActivity = state => state.selected?.profile?.lastActivity
export const isChatEnabled = state => state.activities?.isChatEnabled

export const getOrganisations = state => state.organisation?.organisationNames

